// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '다산제약',
  targetSheetName: '202606_수수료율',
  headerRowIndex: 9,
  headerRowCount: 1,
  dataStartRowIndex: 10,
  columnMapping: {
    drugCode: '약품코드',
    drugName: '제품명',
    price: '보험가',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '계열',
    '구분',
    '생동',
    '자사',
    '제품명',
    '성분명',
    '약품코드',
    '보험가',
    '수수료',
    '포장단위',
    '비고',
  ],
});
